module.exports = {
  baseurl:'https://passionframework.com/APIS/index.php',
  // baseurl:'http://localhost/CodeIgniter/index.php',
   user_op:'/user_op',
   getcategories:'/getcategory',
   getmembers:'/getmembers/1',
   upload_path:'https://passionframework.com/APIS/application/uploads/',
   //upload_path:'http://localhost/CodeIgniter/application/uploads/',
   insert_beneficiery:'/insert_beneficiery',
    update_beneficiery:'/insert_beneficiery/1',
    get_beneficiery:'/get_beneficiery/',
    send_email:'/send_mail/',
    project_module:'/projects_module/',
    project_research:'/research_module/',
    job_posts :'/job_module/',
    product_module:'/product_module/',
    get_echo_systems:'/get_echo_systems',
    verify_user:'/forgotpassword/',
    group_module :'/group_module/',
    insert_ecosystem:'/save_ecosystem',
    get_search_result:'/search_module',
    get_dashboard_content:'/dashboard_module',
    get_csv:'/get_csv/',
    insert_csv:'/insert_csv/',
    mobile_pattener:'[7-9]{1}[0-9]{9}',
    PAGE_RANGE_COUNT:5
    
};
  





/** WEBPACK FOOTER **
 ** ./src/APIS/APIS.js
 **/